import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const SelectedWork = (props) => {
  const projects = props.projects;
  const [filteredProjects, setFilteredProjects] = useState([]);
  useEffect(() => {
    const filtered = projects.filter((project) => project.featured);
    setFilteredProjects(filtered);
  }, [projects]);
  const filter = (filteration) => {
    if (filteration === "latest") {
      const filtered = projects.slice(-4);
      setFilteredProjects(filtered);
    } else if (filteration === "featured") {
      const filtered = projects.filter((project) => project.featured);
      setFilteredProjects(filtered);
    } else {
      const filtered = projects.filter(
        (project) => project.type === filteration
      );
      setFilteredProjects(filtered);
    }
  };

  return (
    <Container>
      <section id="selected-work" className="pt-5 px-5">
        <h3>SELECTED WORK</h3>
        <div className="mb-5 text-center">
          <button
            className="mx-2 mb-3"
            onClick={() => {
              filter("latest");
            }}
          >
            LATEST
          </button>
          <button
            className="mx-2  mb-3"
            onClick={() => {
              filter("featured");
            }}
          >
            FEATURED
          </button>
          <button
            className="mx-2  mb-3"
            onClick={() => {
              filter("js");
            }}
          >
            JAVASCRIPT
          </button>
          <button
            className="mx-2  mb-3"
            onClick={() => {
              filter("react");
            }}
          >
            REACT
          </button>
        </div>
        <Container>
          <Row>
            {filteredProjects.map((project) => (
              <Col lg={6} className="mb-4" key={project.id}>
                <div className="img-wrapper">
                  <img
                    src={project.img}
                    alt={project.name}
                    width="100%"
                    height="250px"
                  />
                  <div className="img-caption">
                    <Link to={`/portfolio/project-details/${project.params}`}>
                      <h3 className="p-3" style={{ border: "3px solid white" }}>
                        SHOW DETAILS
                      </h3>
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default SelectedWork;
